import { render, staticRenderFns } from "./ReservationNotFound.vue?vue&type=template&id=35afa65a"
import script from "./ReservationNotFound.vue?vue&type=script&lang=js"
export * from "./ReservationNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports